import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getProductById } from '../data/products';
import MOCK_PRODUCTS from '../data/products';

const ProductDetailsPage = () => {
  const { id } = useParams();
  const product = getProductById(id);
  const [selectedSize, setSelectedSize] = useState('');
  const [qty, setQty] = useState(1);

  if (!product) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>🏳️</div>
        <h3>Product not found</h3>
        <Link to="/flags" style={{ color: '#ff6600' }}>Browse all flags</Link>
      </div>
    );
  }

  const disc = Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100);
  const related = MOCK_PRODUCTS.filter(p => p.category === product.category && p.id !== product.id).slice(0, 4);
  const waMessage = selectedSize
    ? `Hi, I want to order *${product.name}* – Size: ${selectedSize}, Qty: ${qty}. Price: ₹${product.price * qty}. Please confirm availability.`
    : `Hi, I'm interested in *${product.name}* (₹${product.price}). Please share more details.`;

  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>

      {/* Breadcrumb */}
      <div style={{ background: '#fff', borderBottom: '1px solid #eee', padding: '12px 0' }}>
        <div className="container">
          <nav style={{ fontSize: '14px', color: '#888' }}>
            <Link to="/" style={{ color: '#ff6600', textDecoration: 'none' }}>Home</Link>
            <span style={{ margin: '0 8px' }}>/</span>
            <Link to="/flags" style={{ color: '#ff6600', textDecoration: 'none' }}>Flags</Link>
            <span style={{ margin: '0 8px' }}>/</span>
            <Link to={`/flags/${product.category}`} style={{ color: '#ff6600', textDecoration: 'none' }}>{product.categoryLabel}</Link>
            <span style={{ margin: '0 8px' }}>/</span>
            <span style={{ color: '#333' }}>{product.name}</span>
          </nav>
        </div>
      </div>

      <div className="container py-5">
        <div className="row g-5">

          {/* Left – Image */}
          <div className="col-md-5">
            <div style={{
              background: '#fff', borderRadius: '20px', overflow: 'hidden',
              boxShadow: '0 4px 24px rgba(0,0,0,0.10)', position: 'relative'
            }}>
              {product.badge && (
                <div style={{
                  position: 'absolute', top: '16px', left: '16px', zIndex: 2,
                  background: '#ff6600', color: '#fff', fontSize: '12px',
                  fontWeight: 700, padding: '4px 12px', borderRadius: '12px'
                }}>
                  {product.badge}
                </div>
              )}
              <div style={{
                position: 'absolute', top: '16px', right: '16px', zIndex: 2,
                background: '#28a745', color: '#fff', fontSize: '12px',
                fontWeight: 700, padding: '4px 10px', borderRadius: '12px'
              }}>
                -{disc}% OFF
              </div>
              <img
                src={product.image}
                alt={product.name}
                style={{ width: '100%', display: 'block', maxHeight: '420px', objectFit: 'cover' }}
              />
            </div>

            {/* Features chips below image */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '16px' }}>
              {product.features.map((f, i) => (
                <span key={i} style={{
                  background: '#fff', border: '1px solid #28a745', color: '#28a745',
                  borderRadius: '20px', padding: '4px 14px', fontSize: '13px', fontWeight: 600
                }}>
                  <i className="bi bi-check-circle-fill" style={{ marginRight: '5px' }}></i>{f}
                </span>
              ))}
            </div>
          </div>

          {/* Right – Details */}
          <div className="col-md-7">
            <p style={{ color: '#888', fontSize: '13px', marginBottom: '6px' }}>{product.categoryLabel}</p>
            <h1 style={{ fontWeight: 800, fontSize: '28px', marginBottom: '12px' }}>{product.name}</h1>

            {/* Rating */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <span style={{ color: '#f59e0b', fontSize: '18px' }}>{'★'.repeat(Math.round(product.rating))}</span>
              <span style={{ color: '#f59e0b', fontWeight: 700 }}>{product.rating}</span>
              <span style={{ color: '#888', fontSize: '14px' }}>({product.reviews} reviews)</span>
            </div>


            <p style={{ color: '#555', lineHeight: 1.8, marginBottom: '20px' }}>{product.description}</p>

            {/* Size Selection */}
            {product.sizes && product.sizes.length > 0 && (
              <div style={{ marginBottom: '20px' }}>
                <label style={{ fontWeight: 700, marginBottom: '8px', display: 'block' }}>
                  Select Size:
                  {selectedSize && <span style={{ color: '#ff6600', marginLeft: '8px' }}>{selectedSize}</span>}
                </label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {product.sizes.map(size => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(size)}
                      style={{
                        padding: '8px 18px', borderRadius: '8px', cursor: 'pointer',
                        fontWeight: 600, fontSize: '14px',
                        border: selectedSize === size ? '2px solid #ff6600' : '1.5px solid #ddd',
                        background: selectedSize === size ? '#fff5ee' : '#fff',
                        color: selectedSize === size ? '#ff6600' : '#444',
                        transition: 'all 0.2s'
                      }}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Quantity */}
            <div style={{ marginBottom: '24px' }}>
              <label style={{ fontWeight: 700, marginBottom: '8px', display: 'block' }}>Quantity:</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <button
                  onClick={() => setQty(q => Math.max(1, q - 1))}
                  style={{
                    width: '36px', height: '36px', borderRadius: '8px', border: '1.5px solid #ddd',
                    background: '#fff', fontSize: '20px', cursor: 'pointer', fontWeight: 700
                  }}
                >
                  –
                </button>
                <span style={{ fontSize: '18px', fontWeight: 700, minWidth: '30px', textAlign: 'center' }}>{qty}</span>
                <button
                  onClick={() => setQty(q => q + 1)}
                  style={{
                    width: '36px', height: '36px', borderRadius: '8px', border: '1.5px solid #ddd',
                    background: '#fff', fontSize: '20px', cursor: 'pointer', fontWeight: 700
                  }}
                >
                  +
                </button>
              </div>
            </div>

            {/* CTA Buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '28px' }}>
              <a
                href={`https://wa.me/919700388626?text=${encodeURIComponent(waMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                  padding: '16px', borderRadius: '12px', background: '#25d366',
                  color: '#fff', fontWeight: 700, fontSize: '16px', textDecoration: 'none',
                  boxShadow: '0 4px 16px rgba(37,211,102,0.35)'
                }}
              >
                <i className="bi bi-whatsapp" style={{ fontSize: '22px' }}></i>
                Order on WhatsApp
              </a>
              <a
                href="tel:9700388626"
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                  padding: '14px', borderRadius: '12px', border: '2px solid #ff6600',
                  color: '#ff6600', fontWeight: 700, fontSize: '15px', textDecoration: 'none'
                }}
              >
                <i className="bi bi-telephone-fill"></i>
                Call to Order: 9700388626
              </a>
            </div>

            {/* Trust Badges */}
            <div style={{
              background: '#f8f9fa', borderRadius: '12px', padding: '16px',
              display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px'
            }}>
              {[
                { icon: 'bi-truck', text: 'Fast Delivery Across India' },
                { icon: 'bi-shield-check', text: '100% Quality Guarantee' },
                { icon: 'bi-arrow-repeat', text: 'Easy Returns' },
                { icon: 'bi-patch-check', text: 'Authentic Designs' },
              ].map((b, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#555' }}>
                  <i className={`bi ${b.icon} text-success`} style={{ fontSize: '16px' }}></i>
                  {b.text}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Related Products */}
        {related.length > 0 && (
          <div style={{ marginTop: '60px' }}>
            <h3 style={{ fontWeight: 800, marginBottom: '24px' }}>More from {product.categoryLabel}</h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: '16px'
            }}>
              {related.map(rel => (
                <Link key={rel.id} to={`/flag/${rel.id}`} style={{ textDecoration: 'none' }}>
                  <div style={{
                    background: '#fff', borderRadius: '12px', overflow: 'hidden',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.07)', transition: 'box-shadow 0.2s'
                  }}>
                    <img src={rel.image} alt={rel.name}
                      style={{ width: '100%', height: '140px', objectFit: 'cover' }} />
                    <div style={{ padding: '12px' }}>
                      <p style={{ fontWeight: 600, color: '#222', fontSize: '14px', marginBottom: '4px' }}>{rel.name}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetailsPage;
